import { createFileRoute, redirect } from "@tanstack/react-router";
import { CustomFormPage } from "@/app/partner/pages/settings/custom-form";
import { canAccessRoute } from "@/lib/auth";

export const Route = createFileRoute("/flex/dashboard/custom-form")({
	beforeLoad: async ({ context }) => {
		const { partner } = context;
		const access = canAccessRoute(partner, "customForm");

		if (!access.allowed) {
			throw redirect({ to: "/flex/dashboard" });
		}
	},
	component: CustomFormPage,
});
